export default __webpack_public_path__ + "static/SR France - Fiche de Données Sécurité - Burnt Sugar (Poudre)-0251e486d8dc28fbb4eacc4f1fdd8ed5.pdf";